<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4763_20)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.1421 3.41637C14.4852 5.75952 14.4852 9.55851 12.1421 11.9017C9.79891 14.2448 5.99992 14.2448 3.65677 11.9017C1.31363 9.55851 1.31363 5.75952 3.65677 3.41637C5.99992 1.07323 9.79891 1.07323 12.1421 3.41637ZM13.1905 12.2425C15.5777 9.49257 15.4639 5.32398 12.8492 2.70926C10.1155 -0.0244056 5.68334 -0.0244058 2.94967 2.70926C0.215997 5.44293 0.215997 9.87509 2.94967 12.6088C5.56454 15.2236 9.73348 15.3373 12.4834 12.9497L15.1464 15.6126L15.8535 14.9055L13.1905 12.2425Z" fill="currentColor"/>
<rect x="4.71875" y="4.64651" width="6.5625" height="5.88805" rx="0.5" stroke="currentColor" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_4763_20">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
